import type { GetServerSideProps, NextPage } from 'next';
import { A, G } from '@mobily/ts-belt';
import React from 'react';
import { DynamicRoutePath } from '../../utils/requests/contentstack/dynamicPath';
import { serverLogger } from '../../utils/loggers/server';
import { SlugPageLayout } from '../../components/SlugPageLayout/SlugPageLayout';
import {
  getSlugEntry,
  GetSlugEntryResponse,
} from '../../utils/requests/contentstack/slug';

const rootPath = '/community';

type Params = DynamicRoutePath['params'];

export const getServerSideProps: GetServerSideProps<
  GetSlugEntryResponse,
  Params
> = async ({ params, locale }) => {
  if (!params || A.isEmpty(params.slug)) {
    return {
      notFound: true,
    };
  }

  const pageUrl = `${rootPath}/${params.slug.join('/')}`;

  const entryResponse = await getSlugEntry({
    locale,
    logger: serverLogger,
    rootPath,
    slug: params.slug,
  });

  if (G.isUndefined(entryResponse)) {
    serverLogger({
      level: 'warn',
      team: 'client-onboarding',
      message: 'Required page data is undefined - /community/',
      context: {
        feature: 'id-me',
        page: '/community/[...slug]',
        url: pageUrl,
      },
    });

    return {
      notFound: true,
    };
  }

  return {
    props: entryResponse,
  };
};

const CommunityPage: NextPage<GetSlugEntryResponse> = props => {
  return <SlugPageLayout {...props} />;
};

export default CommunityPage;
